/* ============================================================================
   CONFIGURADOR DE LENTES — estado, navegacao e instrumentacao
   Tema: Claude (custom 0.11)

   Alem do fluxo de selecao de lentes e da etapa "Sua receita", este arquivo
   emite eventos de funil no dataLayer. O objetivo e responder, com dado, em
   qual etapa o cliente desiste — hoje isso e palpite.

   EVENTOS EMITIDOS (prefixo lens_)
     lens_flow_open        abriu o configurador (inclui origem: botao ou provador)
     lens_step_view        entrou numa etapa (nome + posicao)
     lens_option_select    escolheu uma opcao (etapa, opcao, preco)
     lens_step_back        voltou uma etapa
     lens_accessory_add    adicionou acessorio
     lens_accessory_remove removeu acessorio
     lens_summary_view     chegou no resumo (valor total)
     lens_add_to_cart      concluiu (valor, itens, receita)
     lens_add_to_cart_error falhou ao concluir
     lens_flow_abandon     fechou sem concluir (ultima etapa vista)

   Os eventos de receita (prescription_*) e do provador (mk_*) ja existiam e
   foram mantidos com os mesmos nomes, para nao quebrar relatorios.

   PRINCIPIO: nenhum dado sensivel vai para o dataLayer. Grau, DP e arquivo da
   receita NUNCA sao enviados — apenas o metodo escolhido e o status. E toda
   emissao e protegida por try/catch: analytics jamais pode quebrar a venda.

   Faixas de DP/DNP reaproveitam os limites da area "Minhas Receitas"
   (assets/prescriptions.js): DP 55-74mm, DNP 28-38mm.
   ============================================================================ */

var LAH_RX_CONFIG = {
    esf: { min: -10, max: 10, step: 0.25 },
    cil: { min: -6, max: 0, step: 0.25 },
    axis: { min: 1, max: 180, step: 1 },
    add: { min: 0.75, max: 3.5, step: 0.25 },
    dp: { min: 55, max: 74, step: 0.5 },
    dnp: { min: 28, max: 38, step: 0.5 },
    maxFileBytes: 20 * 1024 * 1024,
    allowedExtensions: ['.jpg', '.jpeg', '.png', '.pdf'],
    allowedMimeTypes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
};

/* Sinal sempre explicito (+1.50 / -2.25 / 0.00). */
function lahRxFormatSigned(value) {
    var rounded = Math.round(value * 100) / 100;
    if (rounded === 0) return '0.00';
    return (rounded > 0 ? '+' : '-') + Math.abs(rounded).toFixed(2);
}

function lahRxBuildSignedRange(cfg, descending) {
    var list = [];
    var steps = Math.round((cfg.max - cfg.min) / cfg.step);
    for (var i = 0; i <= steps; i++) {
        list.push(lahRxFormatSigned(cfg.min + i * cfg.step));
    }
    return descending ? list.reverse() : list;
}

function lahRxBuildPlainRange(cfg, decimals) {
    var list = [];
    var steps = Math.round((cfg.max - cfg.min) / cfg.step);
    for (var i = 0; i <= steps; i++) {
        var v = cfg.min + i * cfg.step;
        list.push(decimals ? v.toFixed(decimals) : String(Math.round(v)));
    }
    return list;
}

/* Reconhece "com grau" sem depender de acento/caixa. "Multifocal" precisa de
   checagem propria porque a palavra nao contem a substring "grau". */
function lahRxIsGrau(name) {
    var n = (name || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    if (n.indexOf('sem grau') !== -1) return false;
    if (n.indexOf('apenas armacao') !== -1) return false;
    return n.indexOf('grau') !== -1 || n.indexOf('multifocal') !== -1;
}

/* Emissor unico de eventos. Centralizado para que o try/catch e o contexto
   comum (produto, variante) existam num lugar so. */
function lahTrack(eventName, payload) {
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
    } catch (e) { /* analytics nunca deve quebrar a venda */ }
}

document.addEventListener("alpine:init", () => {
    Alpine.data("ProductLensSelect", () => ({
        currentStep: 1,
        totalSteps: 0,
        currentProduct: JSON.parse(
            document.getElementById("product-lens-json-data").textContent,
        ),
        openLensModal: false,
        currentImage: "",
        formId: "",
        currentVariantId: 0,
        currentVariant: {},
        idViewMore: "",
        hasAccessories: false,
        accessoriesStep: 0,
        steps: [],
        selectedSteps: [],
        selectedIds: [],
        parcels: 6,
        parcelPrice: 0,
        comparePrice: 0,
        price: 0,
        addObject: [],
        kitFree: 0,
        loading: false,
        accessorieList: [],
        accessorieListIds: [],
        selectedAccessorieVariants: {},

        /* ---------------- Instrumentacao ---------------- */
        lensFlowStartedAt: 0,
        lensCompleted: false,
        lensLastStepName: '',
        lensViewedSteps: [],

        /* Contexto comum a todos os eventos do funil */
        lensContext(extra) {
            var base = {
                product_id: this.currentProduct.id,
                product_title: this.currentProduct.title,
                variant_id: this.currentVariant.id,
                variant_sku: this.currentVariant.sku
            };
            return Object.assign(base, extra || {});
        },

        /* Nome legivel da etapa atual, para o relatorio nao ficar so com numeros */
        lensStepName(stepId) {
            if (this.prescriptionEnabled && stepId === this.prescriptionStep) return 'receita';
            if (this.hasAccessories && stepId === this.accessoriesStep) return 'acessorios';
            if (stepId === this.totalSteps) return 'resumo';

            var match = Alpine.raw(this.steps).find(function (s) { return s.id === stepId; });
            return match ? (match.selector || match.endTitle) : ('etapa-' + stepId);
        },

        /* Registra a entrada numa etapa. Evita duplicar quando o cliente volta
           e avanca de novo — o que inflaria o funil artificialmente. */
        lensTrackStepView(stepId) {
            var name = this.lensStepName(stepId);
            this.lensLastStepName = name;

            if (this.lensViewedSteps.indexOf(name) !== -1) return;
            this.lensViewedSteps.push(name);

            lahTrack('lens_step_view', this.lensContext({
                step_name: name,
                step_position: stepId,
                step_total: this.totalSteps
            }));

            if (stepId === this.totalSteps) {
                lahTrack('lens_summary_view', this.lensContext({
                    value: this.price / 100,
                    currency: 'BRL',
                    has_prescription_lens: this.needsPrescription,
                    accessories_count: this.accessorieList.length
                }));
            }
        },

        /* ---------------- Etapa "Sua receita" ---------------- */
        prescriptionEnabled: false,
        prescriptionStep: 0,
        rxView: 'choice',
        rxMethod: '',
        rxFile: null,
        rxFileName: '',
        rxFileError: '',
        rxUploading: false,
        rxTip: '',
        rxDpMode: 'dp',
        rxErrors: {},
        rxShowDpHelp: false,
        rxMeasuring: false,
        rx: {
            odEsf: '0.00', odCil: '0.00', odEixo: '',
            oeEsf: '0.00', oeCil: '0.00', oeEixo: '',
            add: '', dp: '', dnpRight: '', dnpLeft: '',
        },

        get rxEsfOptions() { return lahRxBuildSignedRange(LAH_RX_CONFIG.esf, true); },
        get rxCilOptions() { return lahRxBuildSignedRange(LAH_RX_CONFIG.cil, true); },
        get rxAxisOptions() { return lahRxBuildPlainRange(LAH_RX_CONFIG.axis, 0); },
        get rxAddOptions() { return lahRxBuildSignedRange(LAH_RX_CONFIG.add, false); },
        get rxDpOptions() { return lahRxBuildPlainRange(LAH_RX_CONFIG.dp, 2); },
        get rxDnpOptions() { return lahRxBuildPlainRange(LAH_RX_CONFIG.dnp, 2); },

        get needsPrescription() {
            return Alpine.raw(this.selectedSteps).some(function (i) {
                return lahRxIsGrau(i.itemName);
            });
        },

        get rxIsMultifocal() {
            return Alpine.raw(this.selectedSteps).some(function (i) {
                return (i.itemName || '').toLowerCase().indexOf('multifocal') !== -1;
            });
        },

        get rxNeedsAdd() { return this.rxIsMultifocal; },

        get rxOutOfRange() {
            var extreme = [this.rx.odEsf, this.rx.oeEsf].some(function (v) {
                return Math.abs(parseFloat(v || '0')) >= 10;
            });
            var cyl = [this.rx.odCil, this.rx.oeCil].some(function (v) {
                return parseFloat(v || '0') <= -6;
            });
            return extreme || cyl;
        },

        get rxStatus() {
            if (this.rxMethod === 'upload' && this.rxFileName) return 'submitted';
            if (this.rxMethod === 'manual') return 'submitted';
            return 'pending';
        },

        get rxSummaryLabel() {
            if (this.rxMethod === 'upload' && this.rxFileName) return 'Receita enviada';
            if (this.rxMethod === 'manual') return 'Receita preenchida';
            return 'Enviar apos a compra';
        },

        rxNeedsAxis(eye) {
            var cil = eye === 'od' ? this.rx.odCil : this.rx.oeCil;
            return parseFloat(cil || '0') !== 0;
        },

        selectRxMethod(method) {
            this.rxMethod = method;
            this.rxView = method;
            this.rxErrors = {};
            this.rxTip = '';
            this.rxTrack('prescription_method_selected', { method: method });
        },

        setRxDpMode(mode) {
            this.rxDpMode = mode;
            if (mode === 'dp') {
                this.rx.dnpRight = '';
                this.rx.dnpLeft = '';
            } else {
                this.rx.dp = '';
            }
        },

        /* Medir DP no Provador Virtual: aciona o gatilho oculto ja existente na
           PDP. O fluxo e apenas OCULTADO, preservando o estado preenchido. */
        openDpMeasure() {
            var btn = document.querySelector('.auglio-tryon-btn-product-page');
            if (!btn) {
                this.rxShowDpHelp = false;
                alert('O provador virtual nao esta disponivel para este produto no momento.');
                return;
            }
            this.rxShowDpHelp = false;
            this.rxMeasuring = true;
            document.querySelector('body').classList.remove('hidden-scroll');
            this.rxTrack('prescription_dp_measure_open', {});
            btn.click();
        },

        closeDpMeasure() {
            this.rxMeasuring = false;
            document.querySelector('body').classList.add('hidden-scroll');
        },

        selectRxFile(input) {
            var file = input.files && input.files[0];
            this.rxFileError = '';
            if (!file) return;

            var ext = '.' + file.name.split('.').pop().toLowerCase();
            var okType = LAH_RX_CONFIG.allowedMimeTypes.indexOf(file.type) !== -1 ||
                LAH_RX_CONFIG.allowedExtensions.indexOf(ext) !== -1;

            if (!okType) {
                this.rxFileError = 'Formato invalido. Envie um arquivo JPG, PNG ou PDF.';
                input.value = '';
                this.rxTrack('prescription_upload_error', { reason: 'type' });
                return;
            }
            if (file.size > LAH_RX_CONFIG.maxFileBytes) {
                this.rxFileError = 'Arquivo muito grande. O limite e de 20 MB.';
                input.value = '';
                this.rxTrack('prescription_upload_error', { reason: 'size' });
                return;
            }

            this.rxFile = file;
            this.rxFileName = file.name;
        },

        clearRxFile() {
            this.rxFile = null;
            this.rxFileName = '';
            this.rxFileError = '';
        },

        validateRx() {
            var errors = {};
            if (this.rxMethod === 'manual') {
                if (this.rxNeedsAxis('od') && !this.rx.odEixo) {
                    errors.odEixo = 'Informe o eixo do olho direito.';
                }
                if (this.rxNeedsAxis('oe') && !this.rx.oeEixo) {
                    errors.oeEixo = 'Informe o eixo do olho esquerdo.';
                }
                if (this.rxNeedsAdd && !this.rx.add) {
                    errors.add = 'Informe o valor de adicao.';
                }
            }
            this.rxErrors = errors;

            /* Erro de validacao e sinal de atrito: vale medir. */
            if (Object.keys(errors).length > 0) {
                lahTrack('lens_validation_error', this.lensContext({
                    step_name: 'receita',
                    fields: Object.keys(errors).join(',')
                }));
            }

            return Object.keys(errors).length === 0;
        },

        finishPrescription() {
            if (!this.rxMethod) this.rxMethod = 'whatsapp';
            if (!this.validateRx()) return;

            if (this.rxMethod === 'upload') {
                this.rxTrack('prescription_upload_complete', {});
            } else if (this.rxMethod === 'manual') {
                this.rxTrack('prescription_manual_complete', {});
            } else {
                this.rxTrack('prescription_deferred', {});
            }

            this.currentStep = this.hasAccessories ? this.accessoriesStep : this.totalSteps;
            this.lensTrackStepView(this.currentStep);
        },

        /* Mantido com o nome antigo para nao quebrar relatorios existentes */
        rxTrack(eventName, payload) {
            lahTrack(eventName, payload);
        },

        resetPrescription() {
            this.rxView = 'choice';
            this.rxMethod = '';
            this.rxFile = null;
            this.rxFileName = '';
            this.rxFileError = '';
            this.rxUploading = false;
            this.rxTip = '';
            this.rxDpMode = 'dp';
            this.rxErrors = {};
            this.rxShowDpHelp = false;
            this.rxMeasuring = false;
            this.rx = {
                odEsf: '0.00', odCil: '0.00', odEixo: '',
                oeEsf: '0.00', oeCil: '0.00', oeEixo: '',
                add: '', dp: '', dnpRight: '', dnpLeft: '',
            };
        },

        /* Cart attributes na nomenclatura ja adotada pelo sistema atual. */
        buildRxAttributes(fileUrl) {
            var vid = this.currentVariant.id;
            var attrs = {};
            var grau = '';

            attrs[vid + '_metodoReceita'] = this.rxMethod || 'whatsapp';
            attrs[vid + '_statusReceita'] = this.rxStatus;
            attrs[vid + '_monofocal'] = this.rxIsMultifocal ? 'false' : 'true';

            if (this.rxStatus !== 'submitted') return attrs;

            attrs[vid + '_dataEnvio'] = new Date().toISOString();
            if (fileUrl) attrs[vid + '_urlReceita'] = fileUrl;

            var dp = '';
            if (this.rxDpMode === 'dnp' && (this.rx.dnpRight || this.rx.dnpLeft)) {
                dp = (this.rx.dnpRight || '-') + '/' + (this.rx.dnpLeft || '-');
            } else if (this.rx.dp) {
                dp = this.rx.dp;
            }
            if (dp) attrs[vid + '_numeroDp'] = dp;

            if (this.rxMethod === 'manual') {
                grau = 'ESF ' + this.rx.odEsf + ' | CIL ' + this.rx.odCil;
                if (this.rx.odEixo) grau = grau + ' | EIXO ' + this.rx.odEixo;
                attrs[vid + '_grauOD'] = grau;

                grau = 'ESF ' + this.rx.oeEsf + ' | CIL ' + this.rx.oeCil;
                if (this.rx.oeEixo) grau = grau + ' | EIXO ' + this.rx.oeEixo;
                attrs[vid + '_grauOE'] = grau;

                if (this.rx.add) attrs[vid + '_adicao'] = this.rx.add;
            }

            return attrs;
        },

        openLens(
            defaultImage = "",
            getId = "",
            getAccessories = "",
            kitId = 0,
        ) {
            //for neu PDP layout
            if (document.querySelector(".custom-product-infos-grid")) {
                document
                    .querySelector(".custom-product-infos-grid")
                    .classList.add("no-stick");
            }
            document.querySelector("body").classList.add("hidden-scroll");
            this.kitFree = Number(kitId);
            this.hasAccessories = getAccessories === 'true' ? true : false;
            this.formId = getId;
            this.openLensModal = true;
            this.currentVariantId = Number(
                document.querySelector(`#${getId} [name="id"]`).value,
            );
            const productVariant = Alpine.raw(
                this.currentProduct.variants,
            ).find((x) => x.id === this.currentVariantId);
            if (productVariant && productVariant.featured_image) {
                this.currentImage = `${productVariant.featured_image.src}&width=2000`;
                this.currentVariant = productVariant;
            } else {
                this.currentImage = defaultImage;
                this.currentVariant = Alpine.raw(
                    this.currentProduct.variants,
                )[0];
            }

            /* Marco zero do funil. A origem distingue quem entrou pelo botao
               da PDP de quem veio do provador virtual — sao intencoes
               diferentes e costumam converter de forma diferente. */
            this.lensFlowStartedAt = Date.now();
            this.lensCompleted = false;
            this.lensViewedSteps = [];

            lahTrack('lens_flow_open', this.lensContext({
                source: window.__lahLensSource || 'pdp_button',
                price: this.currentVariant.price / 100,
                currency: 'BRL'
            }));
            window.__lahLensSource = null;

            this.lensTrackStepView(1);
        },
        closeLens() {
            /* Abandono: so conta se nao concluiu. Guarda a ultima etapa vista
               e o tempo gasto — e o dado que responde "onde eles desistem". */
            if (this.openLensModal && !this.lensCompleted) {
                lahTrack('lens_flow_abandon', this.lensContext({
                    last_step: this.lensLastStepName,
                    steps_viewed: this.lensViewedSteps.length,
                    seconds_spent: this.lensFlowStartedAt
                        ? Math.round((Date.now() - this.lensFlowStartedAt) / 1000)
                        : 0,
                    value_at_abandon: this.price / 100,
                    currency: 'BRL'
                }));
            }

            this.openLensModal = false;
            this.currentStep = 1;
            this.currentVariantId = 0;
            this.currentVariant = {};
            this.selectedSteps = [];
            this.selectedIds = [];
            this.parcelPrice = 0;
            this.comparePrice = 0;
            this.price = 0;
            this.addObject = [];
            this.accessorieList = [];
            this.accessorieListIds = [];
            this.selectedAccessorieVariants = {};
            this.resetPrescription();
            this.lensViewedSteps = [];
            this.lensLastStepName = '';
            document.querySelector("body").classList.remove("hidden-scroll");
            if (document.querySelector(".custom-product-infos-grid")) {
                document
                    .querySelector(".custom-product-infos-grid")
                    .classList.remove("no-stick");
            }
        },
        calcPrice() {
            let itemsPrice = 0;
            let compareItemsPrice = 0; //variantComparePrice
            const selectedList = Alpine.raw(this.selectedSteps);
            selectedList.forEach((item) => {
                itemsPrice += item.variantPrice;
                compareItemsPrice +=
                    item.variantComparePrice > item.variantPrice
                        ? item.variantComparePrice
                        : item.variantPrice;
            });
            if (this.accessorieList.length > 0) {
                Alpine.raw(this.accessorieList).forEach((item) => {
                    const itemPrice = item.price * item.quantity;
                    itemsPrice += itemPrice;
                    compareItemsPrice += itemPrice;
                });
            }
            const productPrice = this.currentVariant.price;
            const productComparePrice =
                this.currentVariant.compare_at_price > this.currentVariant.price
                    ? this.currentVariant.compare_at_price
                    : this.currentVariant.price;
            const total = itemsPrice + productPrice;
            const totalCompare = compareItemsPrice + productComparePrice;
            this.price = total;
            this.comparePrice = totalCompare;
            this.parcelPrice = total / this.parcels;
        },

        stepAfterLenses() {
            if (this.prescriptionEnabled && this.needsPrescription) {
                this.rxTrack('prescription_step_view', {});
                return this.prescriptionStep;
            }
            if (this.hasAccessories) return this.accessoriesStep;
            return this.totalSteps;
        },

        nextStep(element) {
            const seletedList = [...Alpine.raw(this.selectedSteps)];
            const nextStepId = element.dataset.nextStep;
            const currentId = element.dataset.itemId;
            const currentName = element.dataset.itemName;
            const objSteps = Alpine.raw(this.steps);
            const currentStepItem = objSteps.find(
                (x) => x.id === this.currentStep,
            );
            //product item data
            const variantId = Number(
                element.querySelector('[name="item-variant-id"]').value,
            );
            const variantComparePrice = Number(
                element.querySelector('[name="item-variant-compare-price"]')
                    .value,
            );
            const variantPrice = Number(
                element.querySelector('[name="item-variant-price"]').value,
            );

            const newItem = {
                id: currentStepItem.id,
                selector: currentStepItem.selector,
                endTitle: currentStepItem.endTitle,
                itemId: currentId,
                itemName: currentName,
                variantId: variantId,
                variantComparePrice: variantComparePrice,
                variantPrice: variantPrice,
            };

            const checkHasItem = !seletedList.length
                ? -1
                : seletedList.findIndex((x) => x.id === currentStepItem.id);

            /* Troca de opcao na mesma etapa e sinal de indecisao — diferente
               de uma escolha direta. Registramos os dois casos. */
            const isChange = checkHasItem > -1;

            if (isChange) {
                seletedList.splice(checkHasItem, 1);
            }
            seletedList.push(newItem);
            this.selectedIds = seletedList.map((x) => x.itemId);
            this.selectedSteps = seletedList;

            lahTrack('lens_option_select', this.lensContext({
                step_name: currentStepItem.selector || currentStepItem.endTitle,
                step_position: currentStepItem.id,
                option_name: currentName,
                option_price: variantPrice / 100,
                is_change: isChange,
                currency: 'BRL'
            }));

            if (nextStepId) {
                const nextStep = objSteps.find(
                    (x) => x.selector === nextStepId,
                );
                if (nextStep) {
                    this.currentStep = nextStep.id;
                } else {
                    this.currentStep = this.stepAfterLenses();
                }
            } else {
                this.currentStep = this.stepAfterLenses();
            }
            // recalcule price
            this.calcPrice();
            this.lensTrackStepView(this.currentStep);
        },

        /* Navegacao para tras nao destroi a receita nem as escolhas ja feitas
           nas etapas finais: apenas retrocede de forma linear. */
        prevStep() {
            const useRx = this.prescriptionEnabled && this.needsPrescription;
            const fromStep = this.lensStepName(this.currentStep);

            if (this.currentStep === this.totalSteps) {
                if (this.hasAccessories) {
                    this.currentStep = this.accessoriesStep;
                    this.lensTrackBack(fromStep);
                    return;
                }
                if (useRx) {
                    this.currentStep = this.prescriptionStep;
                    this.lensTrackBack(fromStep);
                    return;
                }
            }
            if (this.hasAccessories && this.currentStep === this.accessoriesStep && useRx) {
                this.currentStep = this.prescriptionStep;
                this.lensTrackBack(fromStep);
                return;
            }
            if (useRx && this.currentStep === this.prescriptionStep) {
                /* Dentro da receita, voltar primeiro sai da sub-tela. */
                if (this.rxView !== 'choice') { this.rxView = 'choice'; return; }
                const selecteds = Alpine.raw(this.selectedSteps);
                if (selecteds.length) {
                    this.currentStep = selecteds[selecteds.length - 1].id;
                }
                this.lensTrackBack(fromStep);
                return;
            }

            if (this.currentStep > 1) {
                const selecteds = [...Alpine.raw(this.selectedSteps)];
                const lastIdx = selecteds.length - 1;
                this.currentStep = selecteds[lastIdx].id;
                selecteds.splice(lastIdx, 1);
                this.selectedSteps = selecteds;
                this.selectedIds = selecteds.map((x) => x.itemId);
                this.lensTrackBack(fromStep);
            }
        },

        lensTrackBack(fromStep) {
            lahTrack('lens_step_back', this.lensContext({
                from_step: fromStep,
                to_step: this.lensStepName(this.currentStep)
            }));
            this.lensLastStepName = this.lensStepName(this.currentStep);
        },

        finishStep() {
            this.currentStep = this.totalSteps;
            this.lensTrackStepView(this.currentStep);
        },
        selectAccessorieVariant(productId, variantId, variantTitle, price, comparePrice, productTitle, imageUrl = '') {
    const productKey = Number(productId);

    this.selectedAccessorieVariants = {
        ...this.selectedAccessorieVariants,
        [productKey]: {
            product_id: productKey,
            id: Number(variantId),
            variant_title: variantTitle,
            title: productTitle,
            price: Number(price),
            compare_at_price: Number(comparePrice || 0),
            image: imageUrl,
        },
    };

    this.$nextTick(() => {
    const accessorieImage = document.querySelector(
        `[data-accessory-image="${productKey}"]`
    );

    if (accessorieImage && imageUrl) {
        accessorieImage.src = imageUrl;
    }
});

    const selectedIdx = this.accessorieList.findIndex(
        (x) => x.product_id === productKey,
    );

    if (selectedIdx > -1) {
        this.accessorieList[selectedIdx] = {
            product_id: productKey,
            id: Number(variantId),
            title: `${productTitle} - ${variantTitle}`,
            price: Number(price),
            compare_at_price: Number(comparePrice || 0),
            image: imageUrl,
            quantity: 1,
        };

        this.accessorieList = [...this.accessorieList];
        this.accessorieListIds = this.accessorieList.map((x) => x.id);
        this.calcPrice();
    }
},

isAccessorieAdded(productId) {
    return this.accessorieList.some(
        (x) => x.product_id === Number(productId),
    );
},

toggleAccessorie(productId) {
    const productKey = Number(productId);
    const selectedVariant = this.selectedAccessorieVariants[productKey];

    if (!selectedVariant) return;

    const selectedIdx = this.accessorieList.findIndex(
        (x) => x.product_id === productKey,
    );

    if (selectedIdx > -1) {
        this.accessorieList.splice(selectedIdx, 1);
        lahTrack('lens_accessory_remove', this.lensContext({
            accessory_title: selectedVariant.title,
            accessory_price: selectedVariant.price / 100,
            currency: 'BRL'
        }));
    } else {
        this.accessorieList.push({
            product_id: productKey,
            id: selectedVariant.id,
            title: `${selectedVariant.title} - ${selectedVariant.variant_title}`,
            price: selectedVariant.price,
            compare_at_price: selectedVariant.compare_at_price,
            image: selectedVariant.image,
            quantity: 1,
        });
        lahTrack('lens_accessory_add', this.lensContext({
            accessory_title: selectedVariant.title,
            accessory_price: selectedVariant.price / 100,
            currency: 'BRL'
        }));
    }

    this.accessorieList = [...this.accessorieList];
    this.accessorieListIds = this.accessorieList.map((x) => x.id);
    this.calcPrice();
},

isAccessorieVariantAdded(variantId) {
    return this.accessorieList.some(
        (x) => x.id === Number(variantId),
    );
},

toggleAccessorieVariant(productId, variantId, productTitle, variantTitle, price, comparePrice, imageUrl = '') {
    const variantKey = Number(variantId);

    const selectedIdx = this.accessorieList.findIndex(
        (x) => x.id === variantKey,
    );

    if (selectedIdx > -1) {
        this.accessorieList.splice(selectedIdx, 1);
        lahTrack('lens_accessory_remove', this.lensContext({
            accessory_title: productTitle,
            accessory_variant: variantTitle,
            accessory_price: Number(price) / 100,
            currency: 'BRL'
        }));
    } else {
        this.accessorieList.push({
            product_id: Number(productId),
            id: variantKey,
            title: variantTitle && variantTitle !== 'Default Title'
                ? `${productTitle} - ${variantTitle}`
                : productTitle,
            price: Number(price),
            compare_at_price: Number(comparePrice || 0),
            image: imageUrl,
            quantity: 1,
        });
        lahTrack('lens_accessory_add', this.lensContext({
            accessory_title: productTitle,
            accessory_variant: variantTitle,
            accessory_price: Number(price) / 100,
            currency: 'BRL'
        }));
    }

    this.accessorieList = [...this.accessorieList];
    this.accessorieListIds = this.accessorieList.map((x) => x.id);
    this.calcPrice();
},

        async validateCart() {
            this.loading = true;
            try {
                const resp = await fetch("/cart.js", {
                    method: "GET",
                    headers: { "Content-Type": "application/json" },
                });
                if (!resp.ok) throw new Error("Erro");
                const cart = await resp.json();
                if (!cart.items) {
                    this.addToCart();
                    this.loading = false;
                } else {
                    this.loading = false;
                    //valida se item já está no carrinho
                    const hasItem = cart.items.find(
                        (x) => x.id == this.currentVariant.id,
                    );
                    if (!hasItem) {
                        this.addToCart();
                    } else {
                        /* Bloqueio por duplicidade: atrito real, vale medir */
                        lahTrack('lens_add_to_cart_error', this.lensContext({
                            reason: 'duplicate_in_cart'
                        }));
                        alert(
                            "O produto que você está tentando personalizar já existe no seu carrinho!",
                        );
                    }
                }
            } catch (e) {
                console.error(e);
                lahTrack('lens_add_to_cart_error', this.lensContext({
                    reason: 'cart_fetch_failed'
                }));
            } finally {
                console.log("final pegou carrinho");
            }
        },
        async addToCart() {
            this.loading = true;
            const sendRx = this.prescriptionEnabled && this.needsPrescription;
            const mainItem = {
                quantity: 1,
                id: this.currentVariant.id,
                properties: {
                    custom: "true",
                },
            };
            const hasMultiFocal = this.selectedSteps.find(
                (x) => x.itemName.toLowerCase() === "multifocal",
            );
            if (hasMultiFocal) {
                mainItem.properties["multifocal"] = "true";
            }
            const onlyFrames = this.selectedSteps.find((x) =>
                x.itemName.toLowerCase().includes("apenas armação"),
            );
            if (!onlyFrames) {
                mainItem.properties["lentes"] = "true";
            }

            /* Etiqueta legivel no carrinho, espelhando o status do Resumo.
               O link do arquivo vai em propriedade com prefixo "_", que a
               Shopify oculta do carrinho mas mantem visivel no Admin. */
            if (sendRx) {
                mainItem.properties["Receita"] = this.rxSummaryLabel;
            }

            const itemsList = [];
            this.selectedSteps.forEach((item) => {
                if (
                    !item.itemName.includes("apenas armação") &&
                    item.variantId !== 0
                ) {
                    itemsList.push({
                        quantity: 1,
                        id: item.variantId,
                        properties: {
                            mainProduct: this.currentVariant.id,
                        },
                    });
                }
            });

            // add kit free
            if (this.kitFree !== 0) {
                itemsList.push({
                    quantity: 1,
                    id: this.kitFree,
                    properties: {
                        mainProduct: this.currentVariant.id,
                    },
                });
            }

            // add Accessories
            if (this.accessorieList.length > 0) {
                Alpine.raw(this.accessorieList).forEach((item) => {
                    itemsList.push({
                        id: item.id,
                        quantity: item.quantity,
                        properties: {
                            mainProduct: this.currentVariant.id,
                            lentesAcessorios: "true",
                        },
                    });
                });
            }

            this.addObject = [mainItem].concat(itemsList);

            //send product to shopify
            try {
                var rxFileUrl = '';
                var rawFile = Alpine.raw(this.rxFile);

                if (sendRx && rawFile) {
                    /* O arquivo so sobe agora, no momento do pedido. O upload
                       nativo da Shopify exige multipart, por isso o item
                       principal vai separado dos demais. */
                    this.rxUploading = true;
                    const fd = new FormData();
                    fd.append('id', mainItem.id);
                    fd.append('quantity', 1);
                    Object.keys(mainItem.properties).forEach(function (k) {
                        fd.append('properties[' + k + ']', mainItem.properties[k]);
                    });
                    fd.append('properties[_ReceitaArquivo]', rawFile);

                    const fileResp = await fetch('/cart/add.js', { method: 'POST', body: fd });
                    if (!fileResp.ok) throw new Error('Falha ao enviar a receita');
                    const added = await fileResp.json();
                    if (added && added.properties && added.properties['_ReceitaArquivo']) {
                        rxFileUrl = added.properties['_ReceitaArquivo'];
                    }
                    this.rxUploading = false;
                } else {
                    itemsList.unshift(mainItem);
                }

                if (itemsList.length > 0) {
                    const resp = await fetch("/cart/add.js", {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ items: itemsList }),
                    });
                    if (!resp.ok) throw new Error("Erro");
                }

                if (sendRx) {
                    const attrs = this.buildRxAttributes(rxFileUrl);
                    await fetch('/cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ attributes: attrs }),
                    });
                }

                /* Conversao do funil. Marca lensCompleted ANTES do redirect
                   para o closeLens nao registrar abandono por engano. */
                this.lensCompleted = true;

                lahTrack('lens_add_to_cart', this.lensContext({
                    value: this.price / 100,
                    currency: 'BRL',
                    items_count: this.addObject.length,
                    accessories_count: this.accessorieList.length,
                    has_prescription_lens: this.needsPrescription,
                    is_multifocal: this.rxIsMultifocal,
                    prescription_method: sendRx ? (this.rxMethod || 'whatsapp') : 'nao_aplicavel',
                    prescription_status: sendRx ? this.rxStatus : 'nao_aplicavel',
                    seconds_spent: this.lensFlowStartedAt
                        ? Math.round((Date.now() - this.lensFlowStartedAt) / 1000)
                        : 0
                }));

                document.location.href = "/cart";
                this.loading = false;
            } catch (e) {
                console.error(e);
                this.rxUploading = false;
                this.loading = false;

                lahTrack('lens_add_to_cart_error', this.lensContext({
                    reason: sendRx && rawFile ? 'prescription_upload_failed' : 'cart_add_failed'
                }));

                alert('Nao foi possivel concluir. Verifique sua conexao e tente novamente.');
            } finally {
                this.rxUploading = false;
                this.loading = false;
            }
        },
    }));
});
